import { render } from "./PrimaryButtonIcon.vue?vue&type=template&id=b169b8ac"
import script from "./PrimaryButtonIcon.vue?vue&type=script&lang=js"
export * from "./PrimaryButtonIcon.vue?vue&type=script&lang=js"

import "./PrimaryButtonIcon.vue?vue&type=style&index=0&id=b169b8ac&lang=scss"
script.render = render

export default script